import React, { useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box } from '@mui/material';

import {
  PageTitleAndSubTitle,
  PendingClaimStatusTable,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';

import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import properties from '../../core-utils/properties';
import planPerformanceMetricsMessages from '../../core-utils/helper-utils/planPerformanceMetricsMessages';
import axios from 'axios';

import Loader from '../../_components/molecules/Loader';
import { ClaimStatusPending } from '../../core-utils/helper-utils/claimStatusPendingHelper';
import {
  numberToCurrencyFormatter,
  numFormatterWithSuffix,
} from '../../core-utils/helper-utils/helper';
import { pageScrollDown } from '../SummaryPage';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { COMMON_TEXTS } from '../../core-utils/messages/CommonConstants';
import { useStores } from '../../stores';
import ReportsModal from '../../_components/organisms/ReportsModal';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import { getMonth } from '../../core-utils/helper-utils/wasteCalculatorInternalPageHelper';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import DateFilter from '../../_components/molecules/DateFilter';
import { observer } from 'mobx-react';

const PendingClaimStatusPage = observer(() => {
  const useStyles = makeStyles()({
    mainDiv: {
      backgroundColor: '',
      border: '',
      marginTop: '40px',
      marginLeft: '63px',
    },
    flexContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '36px',
      marginBottom: '28px',
    },
    OverViewCardMargin: {
      marginRight: '24px',
    },
    GridItem: {
      marginBottom: '27px',
      display: 'inline-block',
    },
    box: {
      display: 'flex',
      flexDirection: 'row',
      boxSizing: 'border-box',
      background: 'white',
      border: '1px solid grey}',

      width: '1176px',
      height: '388px',
    },

    table: {
      width: ' 1176px',
    },
    tableHeading: {
      background: patientAccessTheme.palette.grey[100],
      '& th:first-child': {
        borderRadius: `8px 0 0 0`,
      },
      '& th:last-child': {
        borderRadius: `0 8px 0 0`,
        borderRight: 'none',
      },
    },
    cell: {
      padding: '18px 18px 18px 20px',

      height: '26px',
    },
    memberCell: {
      padding: '18px 18px 18px 20px',
      borderRight: '1px solid ' + patientAccessTheme.palette.grey[300],
      borderBottom: '1px solid ' + patientAccessTheme.palette.grey[300],
      borderTop: '1px solid ' + patientAccessTheme.palette.grey[300],
      height: '56px',
    },
    tableBody: {
      background: patientAccessTheme.palette.status.white,
      '& tr:last-child td:first-child': {
        borderRadius: `0 0 0 8px`,
      },
      '& tr:last-child td:last-child': {
        borderRadius: `0 0 8px 0`,
      },
      '& td:last-child': {
        borderRight: 'none',
      },
      '& tr:last-child td:nth-child(n)': {
        borderBottom: 'none',
      },
    },
    tableGrid: {
      width: 'fit-content',
      border: '1px solid ' + patientAccessTheme.palette.grey[300],
      borderRadius: '8px',
    },
    tableContainer: {
      width: '1176px',
      height: '764px',
      borderRadius: '8px',
      border: '1px solid ' + patientAccessTheme.palette.grey[300],
    },
    scrollBar: {
      '&::-webkit-scrollbar': {
        width: '6px',
        height: '6px',
        backgroundColor: patientAccessTheme.palette.grey[300],
        borderRadius: '13px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: patientAccessTheme.palette.grey[300],
        borderRadius: '13px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: patientAccessTheme.palette.grey[500],
        borderRadius: '13px',
      },
    },
  });
  const { classes } = useStyles();

  const [
    loadingClaimStatusPending,
    setLoadingClaimStatusPending,
  ] = useState<boolean>(false);

  const [claimStatusPendingData, setClaimStatusPendingData] = useState<
    ClaimStatusPending[]
  >([]);
  const [subscribersData, setSubscribersData] = useState<number[]>([]);
  const [openReportsModal, setOpenReportsModal] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);

  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        planPerformanceMetricsMessages.pendingClaims,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  const getClaimsStatusPending = async () => {
    const baseUrl =
      properties.aiqBaseUrl + properties.getClaimsStatusPendingDistribution;

    const requestBody = {
      ...payload,
    };

    await axios
      .post(baseUrl, requestBody, { signal: abortController.signal })
      .then((res) => {
        if (res) {
          setClaimStatusPendingData(res.data?.data?.claimsDistResponse);
          setSubscribersData(res.data?.data?.subscribers);
        }
      })
      .catch(() => {});
  };
  const recommendedTabStore = useStores().recommendedTabStore;

  const apiCalls = async () => {
    setLoadingClaimStatusPending(true);
    isPlanDatesFetched &&
      (await Promise.all([getClaimsStatusPending()]).then(() => {
        setLoadingClaimStatusPending(false);
      }));

    setLoadingClaimStatusPending(false);
  };

  // Edit duration related states and functions

  const employerGroupStore = useStores().employerGroupStore;
  const quarterlyReportStore = useStores().quaterlyReportStore;
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quarterlyReportStore;

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const abortController = new AbortController();

  // useEffects
  useEffect(() => {
    apiCalls();

    return () => {
      abortController.abort();
    };
  }, [
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
  ]);

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  const getRowData = () => {
    const rowData: any = [];

    claimStatusPendingData.forEach((item) => {
      const tableRowData = [];

      const month = getMonth(item.month, item.year);
      tableRowData.push(month);
      item.claimsDistribution?.forEach((item) => {
        if (item.paid_amount !== 0) {
          if (Number(item.paid_amount) >= 1000000) {
            tableRowData.push(
              planPerformanceMetricsMessages.currencySymbol.dollar +
                numFormatterWithSuffix(item.paid_amount),
            );
          } else {
            tableRowData.push(
              numberToCurrencyFormatter(item.paid_amount, true, 0),
            );
          }
        } else {
          tableRowData.push(
            planPerformanceMetricsMessages.currencySymbol.dollar +
              item.paid_amount,
          );
        }
      });

      rowData.push(tableRowData);
    });
    return rowData;
  };

  const getSubscriberData = () => {
    const rowData = [];
    rowData.push('Subscribers');
    subscribersData.forEach((item) => {
      rowData.push(item);
    });

    return rowData;
  };

  const getMonthTabData = () => {
    const rowData = [];
    rowData.push('LAG TRIANGLE');
    claimStatusPendingData[0]?.claimsDistribution.forEach((item) => {
      const month = getMonth(item.paid_month, item.paid_year);
      rowData.push(month);
    });

    return rowData;
  };

  const PendingClaimStatus = () => {
    const [loader] = useState<any>(<Loader />);

    return (
      <div>
        {isPlanDatesLoading || loadingClaimStatusPending ? (
          loader
        ) : (
          <Box>
            <PendingClaimStatusTable
              columns={getSubscriberData()}
              columns1={getMonthTabData()}
              rowsData={getRowData()}
              width="1176px"
            />
          </Box>
        )}
      </div>
    );
  };

  return (
    <div>
      <div className={classes.mainDiv}>
        <>
          <Box style={{ width: '1182px', position: 'relative' }}>
            <PageTitleAndSubTitle
              title={
                planPerformanceMetricsMessages.pageTitlesofPendingClaimStatus
                  .titleAndSubtitle.title
              }
              subTitle={
                planPerformanceMetricsMessages.pageTitlesofPendingClaimStatus
                  .titleAndSubtitle.subTitle
              }
              // showDownloadButton={true}
              downloadButtonAction={() => setOpenReportsModal(true)}
              showQueryDataButton={
                false
                // false ??
                // checkUserAccess(
                //   UserAccessConstants.COHORT_DETAILS,
                //   loginPageStore.userResponse.role.name,
                //   loginPageStore.userFeatures,
                // )
              }
            />
            <div
              style={{
                position: 'absolute',
                top: '-2px',
                left: '305px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography
                fontSize="17px"
                lineHeight="21px"
                textColor={patientAccessTheme.palette.text.mediumemphasis}
                fontType="semiBold"
                margin="0px 8px"
              >
                {COMMON_TEXTS.FOR}
              </Typography>
              <DateFilter />
            </div>

            <TabSelection
              selectedTabIndex={selectedTabIndex}
              setSelectedTabIndex={handleSelectedIndex}
              recommendationFetched={recommendationFetched}
            />
          </Box>
        </>
        <Box
          sx={{
            marginTop: '23px',
          }}
        >
          {selectedTabIndex === 0 && <PendingClaimStatus />}
          {selectedTabIndex === 1 && (
            <RecommendationsTab
              recommendationLoading={recommendationLoading}
              isInternalPage={true}
            />
          )}
        </Box>
        <Box id="ScrollElement"></Box>
      </div>
      {pageScrollDown('ScrollElement')}
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={incurredStartDate}
        endDate={incurredEndDate}
      />
    </div>
  );
});

export default PendingClaimStatusPage;
